import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-equity-analysis-dialogbox',
  templateUrl: './save-equity-analysis-dialogbox.component.html',
  styleUrls: ['./save-equity-analysis-dialogbox.component.scss']
})
export class SaveEquityAnalysisDialogboxComponent {

  equityName = '';

  constructor(
    private dialogRef: MatDialogRef<SaveEquityAnalysisDialogboxComponent>
  ) { }
  save() {
    const name = this.equityName.trim();

    if (name) {
      this.dialogRef.close(name);
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
